import { initMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import ForwardingOption from 'owa-forwarding-option/lib/ForwardingOption';
import { OptionSubCategory } from 'owa-options-core';
import { trace } from 'owa-trace';

const forwardingSubCategory: OptionSubCategory = {
    key: 'forwarding',
    titleStringKey: 'optionTitle_forwarding',
    options: [ForwardingOption],
    onSelected: () => {
        return loadForwardingConfiguration();
    },
};

async function loadForwardingConfiguration(): Promise<boolean> {
    try {
        await initMailboxForwardingConfiguration();
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}

export default forwardingSubCategory;
